<app-navbar (toggleMobileMenu)="toggleMobileNavbar()"></app-navbar>

<div id="top"></div>

<!-- Principale -->
<div class="pt-5 router-cont" #routerContainer>
    <div class="pt-5 mt-5">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- Overlay -->

<app-footer></app-footer>
<cus-sat></cus-sat>
<div class="overlay-mobile-navbar" [ngClass]="{ 'active': isMobileNavbarOpen }">
    <div class="mobile-navbar">
        <button class="close-btn" (click)="toggleMobileNavbar()">✖</button>
        <div *ngFor="let link of mobileLinks" class="nav-link" (click)="navigateTo(link.href)">
            {{ link.text }}
        </div>
    </div>
</div>